<template>
  <generic-modal
    size="large"
    :title="$t('cart configuration')"
    icon="cart"
    image="/images/icons/configuration.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui four item pointing menu" ref="tabs">
        <a class="item active" data-tab="payment_methods">
          <i class="credit card icon"></i>
          {{ $t("payment methods") }}
        </a>
        <a class="item" data-tab="receipt">
          <i class="edit icon"></i>
          {{ $t("receipt") }}
        </a>
        <a class="item" data-tab="fel">
          <i class="receipt icon"></i>
          {{ $t("billing") }}
        </a>
        <a class="item" data-tab="inventory">
          <i class="boxes icon"></i>
          {{ $t("inventory") }}
        </a>
      </div>
      <generic-container
        v-bind:searchable="false"
        v-bind:show_plus="true"
        icon="payment"
        :title="$t('payment methods')"
        v-on:add="add_method"
        class="ui tab segment active"
        data-tab="payment_methods"
      >
        <div class="ui form">
          <div
            class="fields"
            v-for="(method, index) in payment_methods"
            v-bind:key="index"
          >
            <div class="six wide column field">
              <label for>{{ $t("name") }}</label>
              <input
                type="text"
                name="name"
                v-model="payment_methods[index].name"
              />
            </div>
            <div class="six wide column field">
              <div class="ui toggle checkbox">
                <input
                  type="checkbox"
                  name="ask_for_document"
                  v-model="payment_methods[index].ask_for_document"
                />
                <label>{{ $t("ask for document number") }}</label>
              </div>
            </div>
            <div class="field">
              <label for>{{ $t("options") }}</label>
              <div
                class="ui mini red icon button"
                v-on:click="remove_method(method, index)"
              >
                <i class="trash icon"></i>
              </div>
            </div>
          </div>
        </div>
      </generic-container>
      <generic-container
        v-bind:searchable="false"
        v-bind:show_plus="true"
        icon="edit"
        :title="$t('receipt templates')"
        v-on:add="add_layout"
        class="ui tab segment"
        data-tab="receipt"
      >
        <div class="ui grid">
          <div class="four wide column">
            <div
              class="ui vertical fluid pointing menu"
              ref="tabs_layouts"
              v-if="receipt_layouts.length"
            >
              <a
                class="item"
                :data-tab="'t' + idx"
                v-for="(lyt, idx) in receipt_layouts"
                :key="idx"
              >
                <i
                  class="settings icon"
                  :class="{ blue: lyt.set_as_default }"
                ></i>
                {{ lyt.name || $t("unnamed") }}
              </a>
            </div>
          </div>
          <div class="twelve wide stretched column">
            <div
              class="ui tab segment"
              :data-tab="'t' + idx"
              v-for="(lyt, idx) in receipt_layouts"
              :key="idx"
            >
              <div class="ui form">
                <div class="fields">
                  <div class="field">
                    <label for>{{ $t("name") }}</label>
                    <input
                      type="text"
                      name="name"
                      v-model="receipt_layouts[idx].name"
                    />
                  </div>
                  <div class="field">
                    <label for>
                      <i class="settings icon"></i>
                    </label>
                    <div class="ui toggle checkbox">
                      <input
                        type="checkbox"
                        name="set_as_default"
                        v-model="receipt_layouts[idx].set_as_default"
                      />
                      <label>{{ $t("set as default template") }}</label>
                    </div>
                  </div>
                  <div class="field">
                    <label for>
                      <i class="">{{ $t("options") }}</i>
                    </label>
                    <div
                      class="ui red icon button"
                      :data-tooltip="$t('delete')"
                      @click="remove_layout(idx)"
                    >
                      <i class="trash icon"></i>
                    </div>
                  </div>
                </div>
                <div class="field">
                  <label for>{{ $t("template") }}</label>
                  <wysywyg v-model="receipt_layouts[idx].template" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </generic-container>
      <generic-container
        icon="receipt"
        :show_plus="true"
        :title="$t('electronic billing')"
        class="ui tab segment"
        data-tab="fel"
        @add="add_billing"
      >
        <div class="ui grid">
          <div class="four wide column">
            <div
              class="ui vertical fluid pointing menu"
              ref="tabs_billing"
              v-if="billing_templates.length"
            >
              <a
                class="item"
                :data-tab="'b' + idx"
                v-for="(lyt, idx) in billing_templates"
                :key="idx"
              >
                <i
                  class="settings icon"
                  :class="{ blue: lyt.set_as_default }"
                ></i>
                {{ lyt.name || $t("unnamed") }}
              </a>
            </div>
          </div>
          <div class="twelve wide stretched column">
            <div
              class="ui tab segment"
              :data-tab="'b' + idx"
              v-for="(tpl, idx) in billing_templates"
              :key="idx"
            >
              <div class="ui form">
                <div class="three fields">
                  <div class="field">
                    <label for>{{ $t("name") }}</label>
                    <input
                      type="text"
                      name="name"
                      v-model="billing_templates[idx].name"
                    />
                  </div>
                  <div class="field">
                    <label for>{{ $t("provider") }}</label>
                    <div class="ui selection dropdown" ref="provider">
                      <input type="hidden" name="provider" />
                      <i class="dropdown icon"></i>
                      <div class="default text"></div>
                      <div class="menu">
                        <div class="item" :data-idx="idx" data-value="g4s">
                          G4S
                        </div>
                        <div
                          class="item"
                          :data-idx="idx"
                          data-value="megaprint"
                        >
                          Megaprint
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="field">
                    <label for>
                      <i class="settings icon"></i>
                    </label>
                    <div class="ui toggle checkbox">
                      <input
                        type="checkbox"
                        name="set_as_default"
                        v-model="billing_templates[idx].set_as_default"
                      />
                      <label>{{ $t("set as default") }}</label>
                    </div>
                  </div>
                </div>
                <component
                  :is="provider_component(tpl)"
                  @update="prov_setup_updated(idx, $event)"
                  :setup_in="billing_templates[idx].setup"
                  ref="provider_comp"
                ></component>
              </div>
            </div>
          </div>
        </div>
      </generic-container>
      <generic-container
        icon="boxes"
        :title="$t('inventory')"
        class="ui tab segment"
        data-tab="inventory"
      >
        <div class="ui form">
          <div class="two fields">
            <div class="field">
              <label for>{{
                $t("choose reason for inventory discount when product sold")
              }}</label>
              <div class="ui selection dropdown" ref="inventory_reason">
                <input
                  type="hidden"
                  name="inventory_output_reason"
                  v-model="inventory_output_reason"
                />
                <i class="dropdown icon"></i>
                <div class="default text"></div>
                <div class="menu">
                  <div class="item" data-value="1">Option 1</div>
                </div>
              </div>
            </div>
            <div class="field">
              <label for>{{
                $t("choose reason for inventory discount for compound products")
              }}</label>
              <div
                class="ui selection dropdown"
                ref="inventory_compound_reason"
              >
                <input
                  type="hidden"
                  name="inventory_output_compound_reason"
                  v-model="inventory_output_compound_reason"
                />
                <i class="dropdown icon"></i>
                <div class="default text"></div>
                <div class="menu"></div>
              </div>
            </div>
          </div>
        </div>
      </generic-container>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import GenericModal from "@/components/GenericModal";
import GenericContainer from "@/components/GenericContainer";
import G4SBilling from "./G4SBilling";
import MegaprintBilling from "./MegaprintBilling";
import { v4 } from "uuid";
import Wysywyg from "@/components/Wysywyg/Wysywyg";

export default {
  name: "PointOfSaleCartconfigureModal",
  components: {
    "generic-modal": GenericModal,
    "generic-container": GenericContainer,
    Wysywyg,
  },
  computed: {},
  data() {
    return {
      payment_methods: [],
      receipt_layouts: [],
      billing_templates: [],
      inventory_output_reason: undefined,
      inventory_output_compound_reason: undefined,
    };
  },
  methods: {
    add_method() {
      let method = { id: v4(), name: "", ask_for_document: false };
      this.payment_methods.push(method);
    },
    remove_method(method, index) {
      this.payment_methods.splice(index, 1);
    },
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        local_api(vm, "post", "/point_of_sale/do-save-configuration", {
          s: {
            payment_methods: vm.payment_methods,
            receipt_templates: vm.receipt_layouts,
            billing_templates: vm.billing_templates,
            inventory_output_reason: vm.inventory_output_reason,
            inventory_output_compound_reason:
              vm.inventory_output_compound_reason,
          },
        })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    add_layout() {
      let layout = {
        id: v4(),
        name: "",
        template: { html: "", js: "", css: "" },
      };
      this.receipt_layouts.push(layout);
    },
    remove_layout(index) {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to delete template?"),
        function() {
          vm.receipt_layouts.splice(index, 1);
        },
      );
    },
    add_billing() {
      let template = {
        id: v4(),
        name: "",
        provider: "",
        set_as_default: false,
        setup: {},
      };
      this.billing_templates.push(template);
    },
    prov_setup_updated(index, setup) {
      this.billing_templates[index].setup = setup;
    },
    provider_component(template) {
      if (template.provider == "g4s") return G4SBilling;
      else if (template.provider == "megaprint") return MegaprintBilling;
      else return undefined;
    },
  },
  mounted() {
    let vm = this;
    local_api(this, "post", "/point_of_sale/do-get-configuration")
      .then((r) => {
        let conf = r.conf_pos;
        if (conf && conf.setup) {
          vm.payment_methods = conf.setup.payment_methods || [];
          vm.receipt_layouts = conf.setup.receipt_templates || [];
          vm.billing_templates = conf.setup.billing_templates || [];
          vm.inventory_output_reason =
            conf.setup.inventory_output_reason || undefined;
          vm.inventory_output_compound_reason =
            conf.setup.inventory_output_compound_reason || undefined;

          setTimeout(() => {
            vm.billing_templates.map((bt, idx) => {
              if (bt.provider) {
                let trgt = vm.$refs.provider
                  ? vm.$refs.provider[idx]
                  : undefined;
                if (trgt)
                  window.jQuery(trgt).dropdown("set selected", bt.provider);

                /*if (bt.provider == "g4s") vm.provider_component = G4SBilling;
                else if (bt.provider == "doc")
                  vm.provider_component = DOCBilling;
                else vm.provider_component = undefined;*/
              }
            });

            if (vm.inventory_output_reason) {
              window
                .jQuery(vm.$refs.inventory_reason)
                .dropdown("set selected", vm.inventory_output_reason);
            }
            if (vm.inventory_output_compound_reason) {
              window
                .jQuery(vm.$refs.inventory_compound_reason)
                .dropdown("set selected", vm.inventory_output_compound_reason);
            }
          }, 500);
        }

        let invconf = r.conf_inventory;
        if (
          invconf &&
          invconf.setup &&
          invconf.setup.catalogs &&
          invconf.setup.catalogs.outputs
        ) {
          let vls = invconf.setup.catalogs.outputs.map((o) => {
            return { value: o.id, name: o.name, text: o.name };
          });

          window
            .jQuery(vm.$refs.inventory_reason)
            .dropdown("setup menu", { values: vls })
            .dropdown({
              onChange(value) {
                vm.inventory_output_reason = value;
              },
            });

          window
            .jQuery(vm.$refs.inventory_compound_reason)
            .dropdown("setup menu", { values: vls })
            .dropdown({
              onChange(value) {
                vm.inventory_output_compound_reason = value;
              },
            });
        }
      })
      .catch((err) => {
        console.log(err);
        error_toast(err);
      });

    window
      .jQuery(vm.$refs.tabs)
      .find(".item")
      .tab();

    window.jQuery(".ui.accordion").accordion();
  },
  watch: {
    receipt_layouts() {
      setTimeout(() => {
        window
          .jQuery(this.$refs.tabs_layouts)
          .find(".item")
          .tab();
      }, 500);
    },
    billing_templates() {
      let vm = this;
      setTimeout(() => {
        window
          .jQuery(vm.$refs.tabs_billing)
          .find(".item")
          .tab();

        window.jQuery(vm.$refs.provider).dropdown({
          onChange(value, text, $element) {
            let idx = $element.data("idx");
            if (idx != undefined) vm.billing_templates[idx].provider = value;
            /*if (value == "g4s") vm.provider_component = G4SBilling;
            else if (value == "doc") vm.provider_component = DOCBilling;
            else vm.provider_component = undefined;*/
          },
        });
      }, 500);
    },
  },
  updated: function() {},
};
</script>
